// extracted by mini-css-extract-plugin
export default {"reviewPhotoGallery":"tq-z","imageAndVideoCount":"uq-z","imageAndVideoContainer":"vq-z","viewAllReviews":"wq-z"};